/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import BgJpg from '../../assets/images/florai/section-forest-bg.jpg';

// Forest-floor photo backdrop softened by a translucent overlay so section
// content keeps its contrast; parent must be relative with overflow clipped
export default function FloraiSectionBackdrop({ overlayClass, positionClass = 'object-center' }) {
  return (
    <div className="absolute inset-0 z-0" aria-hidden="true">
      <img src={BgJpg} alt="" loading="lazy" decoding="async" className={`w-full h-full object-cover ${positionClass}`} />
      <div className={`absolute inset-0 ${overlayClass}`} />
    </div>
  );
}

FloraiSectionBackdrop.propTypes = {
  overlayClass: PropTypes.string.isRequired,
  positionClass: PropTypes.string,
};
